// extracted by mini-css-extract-plugin
module.exports = {"partnerwrapper":"PartnerWrapper_partnerwrapper__3ms21","slider":"PartnerWrapper_slider__2oET8","book_now":"PartnerWrapper_book_now__3HnnT","flex":"PartnerWrapper_flex__IRXUY"};